// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"DuplicateProduct_cancelButton__3ilyG"};